import React, { Component } from 'react';
import { Fragment } from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

class Confirmation extends Component {
    constructor(props) {
        super(props);
    }

    render() {

        return (
            <span className="d-inline-block mb-2 mr-2">
                <Modal
                    isOpen={this.props.openOverlay}
                    toggle={this.props.closeOverlay}
                    className={this.props.className}
                >
                    {
                        (this.props.subTitle) ?
                            <ModalHeader>
                                {
                                    this.props.subTitle !== undefined &&
                                    <Fragment><span className="subtitle" style={{ fontSize: '18px' }}>{this.props.subTitle}</span></Fragment>
                                }
                            </ModalHeader> : null
                    }
                    <ModalBody style={{ fontSize: '15px' }}>
                        {this.props.confirmationMessage}
                    </ModalBody>
                    <ModalFooter>
                        <Button onClick={this.props.cancelAction}>{this.props.cancelButtonText}</Button>
                        <Button color="primary" onClick={this.props.okAction}>{this.props.okButtonText}</Button>
                    </ModalFooter>
                </Modal>
            </span>
        );
    }
}

export default Confirmation;